import { render } from "./FormClosed.vue?vue&type=template&id=1dd7fec4&scoped=true"
import script from "./FormClosed.vue?vue&type=script&lang=js"
export * from "./FormClosed.vue?vue&type=script&lang=js"

import "./FormClosed.vue?vue&type=style&index=0&id=1dd7fec4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1dd7fec4"

export default script